import { useMemo } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useUserContext } from 'services/userContextStore';

const WATERMARK_COUNT = 48;

function getCachedUser() {
  try {
    const raw = localStorage.getItem('userInfo');
    const info = raw ? JSON.parse(raw) : null;
    return info?.data && typeof info.data === 'object' ? info.data : info;
  } catch {
    return null;
  }
}

// ==============================|| USER WATERMARK ||============================== //

export default function UserWatermark() {
  const userContext = useUserContext();
  const watermarkText = useMemo(() => {
    const cachedUser = getCachedUser();
    const nickname = userContext?.nickname || cachedUser?.nickname || cachedUser?.username || userContext?.username;
    const userId = userContext?.id ?? cachedUser?.id ?? cachedUser?.user_id ?? cachedUser?.admin_user_id;
    const activeRole = userContext?.active_role || userContext?.available_roles?.[0];
    const roleName =
      typeof activeRole === 'string'
        ? activeRole
        : activeRole?.role_name || activeRole?.name || activeRole?.title || activeRole?.label || '';

    if (!nickname || userId === undefined || userId === null || userId === '') return '';
    return `${nickname} | ID: ${userId}${roleName ? ` | Role: ${roleName}` : ''}`;
  }, [userContext]);

  if (!watermarkText) return null;

  return (
    <Box
      aria-hidden="true"
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 1250,
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
        gridAutoRows: 150,
        overflow: 'hidden',
        pointerEvents: 'none',
        userSelect: 'none'
      }}
    >
      {Array.from({ length: WATERMARK_COUNT }, (_, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: 'rotate(-24deg)'
          }}
        >
          <Typography
            component="span"
            sx={{
              color: 'text.primary',
              fontSize: 13,
              fontWeight: 500,
              letterSpacing: 0,
              opacity: 0.1,
              whiteSpace: 'nowrap'
            }}
          >
            {watermarkText}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
